import React, { useState, useEffect, useRef } from "react";
import { FaCheckCircle, FaStar } from "react-icons/fa";
import { PaperBG } from "../kits";
import { motion, AnimatePresence } from "framer-motion";
import howItWorksData from "../data/howItWorks.json";
import RoughBorder from "../kits/LayoutKit/RoughBorder";
import RoughCircle from "../kits/LayoutKit/RoughCircle"; // Pfad anpassen

function HowItWorks() {
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const testimonials = howItWorksData.testimonials;
  const t = testimonials[testimonialIndex];

  // Slider-Ref für RoughBorder (Slider)
  const sliderRef = useRef();
  // Features-Ref für RoughBorder (Features)
  const featuresRef = useRef();

  // Automatischer Slider-Wechsel
  useEffect(() => {
    const interval = setInterval(() => {
      setDirection(1);
      setTestimonialIndex((i) =>
        i === testimonials.length - 1 ? 0 : i + 1
      );
    }, 6000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const prev = () => {
    setDirection(-1);
    setTestimonialIndex((i) =>
      i === 0 ? testimonials.length - 1 : i - 1
    );
  };
  const next = () => {
    setDirection(1);
    setTestimonialIndex((i) =>
      i === testimonials.length - 1 ? 0 : i + 1
    );
  };

  // Framer Motion Variants
  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 32 : -32,
      opacity: 0,
      filter: "blur(6px)",
      scale: 0.98,
      clipPath: "inset(0 100% 0 0)",
      position: "absolute",
    }),
    center: {
      x: 0,
      opacity: 1,
      filter: "blur(0px)",
      scale: 1,
      clipPath: "inset(0 0% 0 0)",
      position: "static",
      transition: {
        duration: 0.75,
        ease: [0.33, 1, 0.68, 1],
      },
    },
    exit: (direction) => ({
      x: direction < 0 ? 32 : -32,
      opacity: 0,
      filter: "blur(6px)",
      scale: 0.98,
      clipPath: "inset(0 100% 0 0)",
      position: "absolute",
    }),
  };

  return (
    <PaperBG fullHeight>
      <section className="py-16">
        <div className="container mx-auto px-6 md:max-w-4xl relative">
          {/* Features-Box */}
          <div
            ref={featuresRef}
            className="relative p-8 bg-gray-50 rounded-xl shadow-lg z-10 mb-12"
          >
            <div className="text-left">
              {howItWorksData.features.map((item, index) => (
                <div className="flex items-start space-x-4" key={index}>
                  <div className="w-4 h-4 flex-shrink-0 mt-6">
                    <FaCheckCircle className="text-gray-800 w-full h-full" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-sm mt-4">
                      {item.title}
                    </h3>
                    <p className="text-gray-700 font-mono text-xs tracking-tight">
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            {/* RoughBorder für Features-Box */}
            <RoughBorder
              parentRef={featuresRef}
              radius={18}
              padding={2}
            color="#AC8E66" 
              strokeWidth={0.3}
              roughness={1}
              bowing={2}
            />
          </div>

          {/* Testimonials-Slider */}
          <div
            ref={sliderRef}
            className="mt-10 md:mt-20 p-8 bg-gradient-to-br from-gray-100 via-white to-gray-100/50 rounded-xl text-center w-full z-20 shadow-lg relative h-[350px] flex flex-col justify-center"
          >
            {/* Slider-Buttons */}
            <button
              onClick={prev}
              className="absolute left-4 top-10 -translate-y-1/2 bg-white border border-black rounded-full w-8 h-8 flex items-center justify-center shadow hover:bg-gray-100"
              aria-label="Vorheriges Testimonial"
            >
              ‹
            </button>
            <button
              onClick={next}
              className="absolute right-4 top-10 -translate-y-1/2 bg-gradient-to-br from-gray-100 via-white to-gray-100/50 border border-black rounded-full w-8 h-8 flex items-center justify-center shadow hover:bg-gray-100"
              aria-label="Nächstes Testimonial"
            >
              ›
            </button>

            <div className="relative min-h-[260px] flex items-center justify-center">
              <AnimatePresence initial={false} custom={direction} mode="wait">
                <motion.div
                  key={testimonialIndex}
                  custom={direction}
                  variants={variants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{
                    duration: 0.75,
                    ease: [0.33, 1, 0.68, 1],
                  }}
                  className="w-full"
                >
                  <div>
                   <div className="relative w-20 h-20 rounded-full bg-gray-50 flex items-center justify-center mx-auto mb-4 overflow-hidden">
  <img
    src={`${process.env.PUBLIC_URL}${t.image}`}
    alt={t.name}
    className="object-contain max-w-[70%] max-h-[70%] z-20"
  />
  <RoughCircle diameter={80} strokeWidth={0.3} color="#18181b" roughness={1} />
</div>
                    <h3 className="text-xs font-mono text-black-800 tracking-tighter">
                      {t.name} {t.company}
                    </h3>
                    <div className="flex justify-center text-brand mt-2 mb-4">
                      {Array.from({ length: t.stars }).map((_, i) => (
                        <FaStar key={i} />
                      ))}
                    </div>
                    <p className="mt-4 border-gray-300 pl-4 font-mono text-xs text-gray-800">
                      {t.quote}
                    </p>
                    <p className="mt-4 font-mono text-xs">{t.role}</p>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

    

            {/* RoughBorder für Slider-Card */}
            <RoughBorder
              parentRef={sliderRef}
              radius={10}
              padding={2}
            color="#AC8E66" 
              strokeWidth={0.3}
              roughness={1}
              bowing={2}
            />
          </div>
        </div>
      </section>
    </PaperBG>
  );
}

export default HowItWorks;
